import type { SVGProps } from 'react'
const IconCheckCircleOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.25 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M2.5 12a9.75 9.75 0 0 1 9.75-9.75A9.75 9.75 0 0 1 22 12c0 5.384-4.365 9.75-9.75 9.75S2.5 17.384 2.5 12"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.243 9.161a.75.75 0 0 1 0 1.06l-4.618 4.618a.75.75 0 0 1-1.06 0l-2.31-2.308a.75.75 0 1 1 1.06-1.061l1.78 1.779 4.087-4.088a.75.75 0 0 1 1.061 0"
      clipRule="evenodd"
    />
  </svg>
)
export default IconCheckCircleOutlineIcon
